export class DisposableListenerRegistry<TEvent> {
    private readonly listeners = new Set<(event: TEvent) => void>();
    private isReleased = false;

    public subscribe(listener: (event: TEvent) => void): () => void {
        if (typeof listener !== "function") {
            throw new TypeError("The event listener must be a function.");
        }

        if (this.isReleased) {
            return () => undefined;
        }

        this.listeners.add(listener);
        let isSubscribed = true;

        return () => {
            if (!isSubscribed) {
                return;
            }

            isSubscribed = false;
            this.listeners.delete(listener);
        };
    }

    public emit(event: TEvent): void {
        for (const listener of [...this.listeners]) {
            try {
                listener(event);
            } catch (error) {
                queueMicrotask(() => {
                    throw error;
                });
            }
        }
    }

    public release(): void {
        this.isReleased = true;
        this.listeners.clear();
    }
}
